import React from 'react'
import { stringifyNum, getLanguageLocale } from 'exports'
import { ITransaction } from '../../interfaces/i-api-deposit'
import { useTranslation } from 'react-i18next'

interface Props {
	id: number
	item: ITransaction
}

export function Transaction({ id, item }: Props) {
	const { t } = useTranslation()
	const $primarydarkbrown = "#6B2900"
	return (
		<tr key={id}>
			<th scope="row">
				{new Date(item.valueDate).toLocaleDateString(
					getLanguageLocale()
				)}
			</th>
			<td>{t(item.paymentTypeText)}</td>
			<td
				style={{
					color: item.amount.toString().startsWith('-')
						? ''
						: $primarydarkbrown,
				}}>
				{stringifyNum(item.amount)}
			</td>
		</tr>
	)
}